<template>
  <div class="container clinic-templates">
    <clinic-show-template ref="showtemplate" @submit="onSubmit"></clinic-show-template>
    <!-- HEADER -->
    <div class="row">
      <div class="col-sm-6">
        <h1 class="page-title">PLANTILLAS DE DOCUMENTOS</h1>
      </div>

      <div class="col-sm-6">
        <input v-model="search" class="form-control icon" type="search" name="search" id="template_index_search"
          placeholder="Escribe el nombre de la plantilla" />
      </div>
      <div class="col-sm-3 text-center">
        <button @click="addNewTemplate" type="button" class="btn btn-wabident-round btn-block">Crear nueva
          plantilla</button>
      </div>
    </div>
    <!-- RESULTS -->
    <div class="row">
      <div class="col-sm-12">
        <div v-show="!has_results_available" class="text-center">
          <h2 class="template-search-empty-message my-4">{{ empty_message }}</h2>
        </div>
        <div v-show="has_results_available" class="template-search-wrapper">
          <table class="table template-search-results">
            <thead>
              <tr>
                <th colspan="7">TITULO</th>
                <th colspan="2">FORMATO</th>
                <th colspan="2">TIPO</th>
                <th colspan="2">ACCIONES</th>
              </tr>
            </thead>
            <tbody>
              <tr class="template-search-results__row" v-for="(template, index) in search_results.data" :key="index"
                @click="templateClicked(template)">
                <td colspan="7">{{ template.title }}</td>
                <td colspan="2">{{ formatName(template.format) }}</td>
                <td colspan="2">{{ typeName(template.type) }}</td>
                <td colspan="2"> <a role="button" class="btn btn-wabident-round xsmall"
                    :href="`/document_template/${template.id}/preview`" target="_blank">V. Previa</a></td>
              </tr>
              <tr></tr>
            </tbody>
          </table>
        </div>
        <div v-show="has_results_available" class="product-search-pagination text-center">
          <button @click="goFirst" :disabled="is_first_page" type="button"
            class="btn btn-primary btn-wabident-round mx-1">
            <i class="fas fa-angle-double-left"></i>
          </button>
          <button @click="goPrev" :disabled="is_first_page" type="button"
            class="btn btn-primary btn-wabident-round mx-1">
            <i class="fas fa-angle-left"></i>
          </button>
          <label class="customer-search-pagination-locator mx-2">
            Página
            {{ current_page }} de {{ total_pages }}
          </label>
          <button @click="goNext" :disabled="is_last_page" type="button"
            class="btn btn-primary btn-wabident-round mx-1">
            <i class="fas fa-angle-right"></i>
          </button>
          <button @click="goLast" :disabled="is_last_page" type="button"
            class="btn btn-primary btn-wabident-round mx-1">
            <i class="fas fa-angle-double-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      search: "",
      search_results: [],
      is_searching: false,
      selected_template: null

    };
  },
  computed: {
    has_results_available() {
      return this.search_results && this.search_results.data && this.search_results.data.length != 0;
    },
    empty_message() {
      if (this.search == "") {
        return "";
      } else {
        return "Lo siento, no pude encontrar ninguna plantilla con ese nombre";
      }
    },
    is_first_page() {
      if (!this.has_results_available) return true;
      return this.search_results.current_page == 1;
    },
    is_last_page() {
      if (!this.has_results_available) return true;
      return this.search_results.current_page == this.search_results.last_page;
    },
    current_page() {
      if (!this.search_results) return 0;
      return this.search_results.current_page;
    },
    total_pages() {
      if (!this.search_results) return 0;
      return this.search_results.last_page;
    },
    ...mapGetters(["msgwindow"])
  },
  watch: {

    search(val) {
      this.searchTemplates();
    },

  },
  methods: {
    formatName(format) {
      return (
        {
          html: "HTML5",
          rich: "HTML Visual",
          markdown: "Markdown",
        }[format] || "Otro"
      );
    },
    typeName(type) {
      return (
        {
          proof: "Justificante",
          consent: "Consentimiento",
          report: "Informe"
        }[type] || "Otro"
      );
    },
    addNewTemplate() {
      this.$refs.showtemplate.showNew();
    },
    templateClicked(prod) {
      this.$refs.showtemplate.showEdit(prod);
    },
    onSubmit() {
      this.searchTemplates();
    },

    goNext() {
      this.searchTemplates(this.current_page + 1);
    },
    goPrev() {
      this.searchTemplates(this.current_page - 1);
    },
    goFirst() {
      this.searchTemplates(1);
    },
    goLast() {
      this.searchTemplates(this.total_pages);
    },

    searchTemplates(page = null) {
      if (!this.is_searching) {
        this.is_searching = true;

        let params = {
          search: this.search,
          page: page,
        };

        axios
          .get("/document_templates", { params })
          .then(response => {
            this.search_results = response.data;
          })
          .catch(err => {
            console.log("[ERR] searchTemplates", err);
            this.msgwindow.error("Error buscando plantillas");
          })
          .then(() => {
            this.is_searching = false;
          });
      }
    }
  },
  mounted() {
    this.searchTemplates();
  }
};
</script>

<style lang="scss">
.clinic-templates {
  margin-top: 30px;
}

.page-title {
  font-size: 32px;
  color: var(--theme-text-color);
  letter-spacing: 0.5px;
  line-height: 1.31;
  font-weight: 500;
  margin-bottom: 27px;
}

.template-search-empty-message {
  color: var(--theme-grey);
  font-size: 24px;
}

.template-search-wrapper {
  margin-top: 30px;
  position: relative;
  overflow-y: scroll;
  width: 100%;
  height: 60vh;
}

.template-search-results {
  width: 100%;

  th {
    font-size: 15px;
    letter-spacing: 0.3px;
    color: var(--theme-grey);
    border: none;
    position: sticky;
    background-color: white;
    top: 0;
  }

  &__row {
    cursor: pointer;
    background-color: transparent;
    transition: all 0.2s;
    border: none;
    border-bottom: 1px #e0e0e0 solid;

    &:hover {
      background-color: var(--theme-highlight);
    }

    td {
      font-size: 16px;
      line-height: 20px;
      color: var(--theme-text-color);

      &.template-code,
      &.template-icon {
        color: var(--theme-grey);
        text-transform: uppercase;

        svg {
          fill: currentColor;
        }
      }
    }
  }
}
</style>
